// extracted by mini-css-extract-plugin
export var copyableField = "_nh-4";
export var customerBadge = "_nh-0";
export var customerInfoTitle = "_nh-2";
export var details = "_nh-1";
export var dropdownContainer = "_nh-5";
export var dropdownImage = "_nh-6";
export var editAssigneeForm = "_nh-a";
export var editButton = "_nh-3";
export var email = "_nh-7";
export var hidden = "_nh-d";
export var input = "_nh-8";
export var saveButton = "_nh-b";
export var shopifyIcon = "_nh-c";
export var suggestionBadge = "_nh-e";
export var suggestionText = "_nh-f";
export var username = "_nh-9";